@if (this.authService.isLoggedIn()) {
  <app-toolbar></app-toolbar>
}

<div class="wrapper">
  <a href="javascript:void(0);" class="ic menu" tabindex="1" (click)="toggleMenu()">
    <span></span>
  </a>
  <a href="javascript:void(0);" class="ic close">
    <span></span>
  </a>
  <div class="content">
    <div class="content-inner">
      <main>
        <div id="mainInner" class="main-inner">
          <router-outlet class="router-outlet"></router-outlet>
        </div>
      </main>
      <footer>
        <div class="mb-2">
          <a href="mailto:info@foxteam.support"> {{ 'FOOTER_REPORT_A_BUG' | translate }}: info&#64;foxteam.support </a>
          &nbsp;|&nbsp;
          <a href="https://foxteam.digital/news" target="_blank">
            {{ 'FOOTER_FOXTEAM_DIGITAL_NEWS' | translate }}
          </a>
        </div>
        <div>
          <a href="https://foxteam.digital" class="logo-footer" target="_blank"></a>
        </div>
      </footer>
    </div>
  </div>

  <div class="nav-overlay" (click)="toggleMenu()"></div>

  <div class="overlay-search"></div>
  <!--<app-info-panel *ngIf="this.authService.isLoggedIn()"></app-info-panel>-->

  <app-loading></app-loading>
  <app-message></app-message>
</div>
